define([
	"csi/def",
	"csi/def/ActionFactory",
	"csi/action/New"
], function(def,ActionFactory,New) {

	return ActionFactory.declare("Insert", New, {
		// String: default tag for action
		m_tag: "Insert",

		constructor: function(obj) {
			if (!this.m_typeControl) {
				this.setMaterialIcon('note_add');
			}
		},

		_needToSwitchContextToParent: function(/*Context*/ctx) {
			return false;
		}
	});
});